

export const INPUT_CHANGE = "[ADD REPORT] INPUT_CHANGE";
export const RESET_FORM = "[ADD REPORT] RESET_FORM";
export const INPUT_ERROR = "[ADD REPORT] INPUT_ERROR";

export const ADD_REPORT_REQUEST = "[ADD REPORT] ADD_REPORT_REQUEST";
export const ADD_REPORT_ERROR = "[ADD REPORT] ADD_REPORT_ERROR";
export const ADD_REPORT_SUCCESS = "[ADD REPORT] ADD REPORT SUCCESS";




// WEBPACK FOOTER //
// ./src/modules/add-report/add-report-action-types.js